// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createMaterial,
  deleteMaterial,
  getMaterialDetail,
  getMaterialList,
  updateMaterial,
} from './materialThunk';

export interface IMaterialState {
  isRefreshMaterialList: boolean;
}

export const initialState: IMaterialState = {
  isRefreshMaterialList: false,
};

const materialSlice = createSlice({
  name: 'material',
  initialState,
  reducers: {
    setRefreshMaterialList(state, action) {
      state.isRefreshMaterialList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get material list
    builder
      .addCase(getMaterialList.pending, (_state) => {})
      .addCase(getMaterialList.fulfilled, (_state) => {})
      .addCase(getMaterialList.rejected, (_state) => {});

    // POST: Create material
    builder
      .addCase(createMaterial.pending, (_state) => {})
      .addCase(createMaterial.fulfilled, (_state) => {})
      .addCase(createMaterial.rejected, (_state) => {});

    // DELETE: Delete material
    builder
      .addCase(deleteMaterial.pending, (_state) => {})
      .addCase(deleteMaterial.fulfilled, (_state) => {})
      .addCase(deleteMaterial.rejected, (_state) => {});

    // GET: Get material detail
    builder
      .addCase(getMaterialDetail.pending, (_state) => {})
      .addCase(getMaterialDetail.fulfilled, (_state) => {})
      .addCase(getMaterialDetail.rejected, (_state) => {});

    // PUT: Update material
    builder
      .addCase(updateMaterial.pending, (_state) => {})
      .addCase(updateMaterial.fulfilled, (_state) => {})
      .addCase(updateMaterial.rejected, (_state) => {});
  },
});

// Action
export const materialActions = materialSlice.actions;

// Selectors
export const selectIsRefreshMaterialList = (state: RootState) => state.material.isRefreshMaterialList;

// Reducer
const materialReducer = materialSlice.reducer;
export default materialReducer;
